import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter, Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from "@angular/core";
import {Service} from "../../../models/service.model";
import {LocationType} from "../../../../commons/types/location.type";
import * as _ from "lodash";
import {ActionReasonModel} from "../../../../action-reasons/models/action-reason.model";
import {ActionReasonEnum} from "../../../../action-reasons/enums/action-reason.enum";
import {ServiceStatusType} from "../../../types/service-status.type";

require('./services-table-row.scss');
@Component({
  standalone: false,
  selector: 'app-services-table-row',
  templateUrl: './services-table-row.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServicesTableRowComponent implements OnInit, OnChanges {

  @Input() service: Service;
  @Input() isSelected: boolean;
  @Input() columns: any;
  @Input() dynamicColumns: any;
  @Input() packageDynamicColumns: any;
  @Input() hasFleetManagementPermission: boolean;
  @Input() hasPricePlanPermission: boolean;
  @Input() configZoneId: string;
  @Input() siteDistanceLargeUnit: string;
  @Input() isDisableActionMenu: boolean;
  @Input() hideActions?: boolean;

  @Output() toggleEvent = new EventEmitter<{ serviceId: string, event: any }>();
  @Output() editAddressEvent = new EventEmitter<string>();
  @Output() filterByTypeEvent = new EventEmitter<any>();

  public locationTypes: typeof LocationType = LocationType;
  public serviceStatusType: typeof ServiceStatusType = ServiceStatusType;
  // public configZoneId: string;
  public activeTooltip: boolean;
  public canCopyProNumber: boolean;
  public isShowIndication: boolean;
  public hasRevertedTask: boolean;
  public actionReasonTypes: typeof ActionReasonEnum = ActionReasonEnum;
  public reasons: any;
  public serviceTasksSpecialInstructions: any = [];
  public serviceTags: string[];
  public enableAgentVehicleBinding: boolean;

  constructor(@Inject('splitService') private splitService,) {
    this.enableAgentVehicleBinding = this.splitService.getEnableAgentVehicleBinding();
  }

  ngOnInit() {
    this.setShowIndicationValue();
    this.setShowRevertIndicationValue();
    this.setActionReasons();
    this.setServiceTasksSpecialInstructions();
    this.setServiceTags();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.service && !changes.service.isFirstChange()) {
      this.setShowIndicationValue();
      this.setShowRevertIndicationValue();
      this.setActionReasons();
      this.setServiceTasksSpecialInstructions();
      this.setServiceTags();
    }
  }


  onToggle(event) {
    event.stopPropagation()
    this.toggleEvent.emit({serviceId: this.service.id, event: event});
  }

  onFilterByType(event) {
    this.filterByTypeEvent.emit(event);
  }

  private setShowIndicationValue() {
    this.isShowIndication = !!this.service?.taskList.find((t) => {
      return !!(t.agentComment || t?.freePictureUrls?.length)
    })
  }

  private setActionReasons() {
    this.reasons = _.compact(_.flatMap(this.service.taskList, 'actionReasons')).map((a) => a.reason);
  }

  private setShowRevertIndicationValue() {
    this.hasRevertedTask = false;
    const tasksActionReasons: ActionReasonModel[] = _.compact(_.flatMap(this.service.taskList, 'actionReasons'));

    for (let i = 0; i < tasksActionReasons.length; i++) {
      if (tasksActionReasons[i].type === this.actionReasonTypes.Revert) {
        this.hasRevertedTask = true;
        break;
      }
    }
  }

  private setServiceTasksSpecialInstructions() {
    this.serviceTasksSpecialInstructions = [];

    this.service.taskList.forEach(t => {
      if (!!t.taskSpec.extraInfo) {
        const specialInstruction = {
          purpose: t.taskSpec.purpose,
          instruction: t.taskSpec.extraInfo
        }
        this.serviceTasksSpecialInstructions.push(specialInstruction);
      }
    })
  }

  private setServiceTags() {
    this.serviceTags = [];

    if (!!this.service.tagNames?.length) {
      this.serviceTags = this.serviceTags.concat(this.service.tagNames);
    }

    if (!!this.service.accountReference?.tags?.length) {
      this.serviceTags = this.serviceTags.concat(this.service.accountReference.tags);
    }
  }
}
